import { useEffect } from 'react';
import { App, APP_EVENTS } from '../types/museum/museum';
import { useTransition } from '../contexts/TransitionContext';
import { useMusic } from '../contexts/MusicContext';

export const useHallEvents = (app: App | undefined, setActivePortal: (portalName: string) => void) => {
  const { setIsPageTransitioning, setIsSceneLoaded } = useTransition();
  const { fadeAndNavigate } = useMusic();

  useEffect(() => {
    if (!app) return;

    console.log('Hall app events initialized');

    app.appEventsBus.on(APP_EVENTS.ACTIVE_PORTAL, (portalName: string) => {
      setActivePortal(portalName);
    });

    app.appEventsBus.on(APP_EVENTS.SET_HALL_ACTIVE_PORTAL, (portalName: string) => {
      setActivePortal(portalName);
    });

    app.appEventsBus.on(APP_EVENTS.PORTAL_CLICK, (portalName) => {
      setIsSceneLoaded(false);
      setIsPageTransitioning(true);
      
      if (portalName.toLowerCase() === 'hall') {
        fadeAndNavigate('/?preloader=true');
      } else {
        fadeAndNavigate(`/museum?target=${encodeURIComponent(portalName.toLowerCase())}&preloader=true`);
      }
    });

    let point = false;
    let timeout = 0;

    app.appEventsBus.on(APP_EVENTS.PORTAL_OVER, (portalName: string) => {
      point = true;
      clearTimeout(timeout)
      //@ts-ignore
      timeout = setTimeout(() => (point = false), 20)
    });

    document.addEventListener('pointermove', () => {
      if (point) {
        document.body.style.cursor = 'pointer';
      } else {
        document.body.style.cursor = 'auto';
      }
    })

    return () => {
      app.appEventsBus.off(APP_EVENTS.ACTIVE_PORTAL);
      app.appEventsBus.off(APP_EVENTS.HALL_CAMERA_ROTATION);
    };
  }, [app, setActivePortal]);
}; 